import { FC, memo } from 'react'
import { IonDatetime, IonLabel } from '@ionic/react'
import { addYears, format, formatISO, parseISO } from 'date-fns'

interface IDateTimePicker {
  value?: number | null
  label?: string
  onChange?: ({ value }: { value: number }) => void
  labelSuffix?: JSX.Element
}

const DateTimePickerComponent: FC<IDateTimePicker> = ({
  onChange,
  label,
  labelSuffix,
  value,
}) => {
  const today = new Date()
  const min = format(today, 'yyyy-MM-dd')
  const max = format(addYears(today, 10), 'yyyy-MM-dd')

  return (
    <div>
      {label && (
        <IonLabel className="pl-4 mb-2 block font-normal">
          {label}
          {labelSuffix}
        </IonLabel>
      )}
      <IonDatetime
        color="success"
        className="max-w-none"
        presentation="date-time"
        min={min}
        max={max}
        value={value && formatISO(new Date(value))}
        onIonChange={(e) => {
          onChange({
            value: parseISO(e.detail.value as string).getTime(),
          })
        }}
      ></IonDatetime>
    </div>
  )
}

export const DateTimePicker = memo(DateTimePickerComponent)
